// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conference-view-container {
  width: 100%;
  height: 0;
  background-color: var(--dialog-background-color);
  transition: all 0.5s ease-out;
  display: flex;
  flex-direction: row;
  position: relative;

  --conference-view-item-height: 240px;
  --conference-view-padding: var(--dialog-element-gap);
}

.conference-view-container-visible {
  height: calc(var(--conference-view-item-height) + (2 * var(--conference-view-padding)) + 2px);
  border-bottom: 1px solid var(--border-color);
  pointer-events: all;
}

.conference-view-scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  flex-grow: 1;
}

.conference-view-user-list {
  width: fit-content;
  min-width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: var(--conference-view-padding);
  display: flex;
  flex-direction: row;
  gap: var(--conference-view-padding);
  align-items: center;
  justify-content: center;
  background-color: var(--light-blue-background-color);
}

.conference-view-item {
  position: relative;
  height: var(--conference-view-item-height);
  width: calc(var(--conference-view-item-height) * 1.3333333333);
  border: 1px solid var(--border-color);
  border-radius: var(--dialog-border-radius);
  flex-shrink: 0;
  background-color: white;

  > video {
    width: 100%;
    height: 100%;
    border-radius: var(--dialog-border-radius);
  }

  > img {
    position: absolute;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: var(--dialog-border-radius);
  }
}

.conference-view-item-name {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--blue-background-color);
  color: var(--text-contrast-color);
  border-top-right-radius: var(--input-element-gap-small);
  border-top-left-radius: var(--input-element-gap-small);
  padding: 0 var(--input-element-gap-small);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}

.conference-view-button-container-left,
.conference-view-button-container-right {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--conference-view-padding);
  align-items: center;
  justify-content: flex-start;
  padding: var(--conference-view-padding);
  box-sizing: border-box;
}

.conference-view-button-container-left .icon-display-numbered,
.conference-view-button-container-right .icon-display-numbered {
  flex-direction: column;
  padding: 0;
}

.conference-view-button-container-left {
  border-right: 1px solid var(--border-color);
}

.conference-view-button-container-right {
  border-left: 1px solid var(--border-color);
}

.conference-view-outer-left-container,
.conference-view-outer-right-container {
  position: absolute;
  top: 100%;
  padding: calc(var(--conference-view-padding) / 2);
  background-color: var(--dialog-background-color);
  z-index: 1;
  border-bottom: 1px solid var(--border-color);
  border-top: 1px solid var(--border-color);
  opacity: 0.75;
}

.conference-view-outer-left-container {
  left: 0;
  border-right: 1px solid var(--border-color);
  border-bottom-right-radius: var(--overlay-panel-border-radius);
}

.conference-view-outer-right-container {
  right: 0;
  border-left: 1px solid var(--border-color);
  border-bottom-left-radius: var(--overlay-panel-border-radius);
}

.confenrence-view-session-name-container {
  height: var(--input-element-height);
  min-width: var(--input-element-height);
  padding: 0 var(--conference-view-padding);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > h2 {
    margin: 0;
  }
}

.conference-view-item-speaking {
  -webkit-box-shadow: 0px 0px 10px 2px var(--warn-color);
  box-shadow: 0px 0px 10px 2px var(--warn-color);
  transition: all 0.5s ease-out;
}

.conference-view-item-mainstream-container,
.conference-view-item-substream-container {
  background-color: var(--dark-grey);
}

.conference-view-item-shared-stream {
  position: relative;
}

.conference-view-item-shared-stream,
.conference-view-item-mainstream,
.conference-view-item-substream,
.conference-view-item-mainstream-container {
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.conference-view-item-substream-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 40%;
  height: 40%;
  cursor: zoom-in;
  border-radius: inherit;
}

.conference-view-item-maximize-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.5s ease-out;
  stroke: var(--dialog-background-color);
  stroke-opacity: 0.75;
  stroke-width: 20;
}

.conference-view-item-mainstream-container:hover .conference-view-item-maximize-button {
  opacity: 1;
}

.conference-view-item-toggle-stream-button {
  position: absolute;
  bottom: var(--input-element-gap-small);
  left: var(--input-element-gap-small);
  opacity: 0;
  transition: opacity 0.5s ease-out;
  stroke: var(--dialog-background-color);
  stroke-opacity: 0.75;
  stroke-width: 20;
}

.conference-view-item-mainstream-container:hover .conference-view-item-toggle-stream-button {
  opacity: 1;
}

.conference-view-empty {
  font-size: var(--font-size-l);
}

.conference-view-item-screenshare-previous,
.conference-view-item-screenshare-next {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: var(--input-element-height);
  cursor: pointer;
  stroke: var(--dialog-background-color);
  stroke-opacity: 0.75;
  stroke-width: 20;
  font-size: var(--font-size-xl);
  display: flex;
  justify-content: center;
  align-items: center;
}

.conference-view-item-screenshare-previous {
  left: 0px;
  background: linear-gradient(to right, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.2) 40%, rgba(255,255,255,0.1) 60%, transparent 100%);
  border-bottom-left-radius: inherit;
  border-top-left-radius: inherit;
}

.conference-view-item-screenshare-previous:hover {
  background: linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 40%, rgba(255,255,255,0.1) 65%, transparent 100%);
}

.conference-view-item-screenshare-next {
  right: 0px;
  background: linear-gradient(to left, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.2) 40%, rgba(255,255,255,0.1) 60%, transparent 100%);
  border-bottom-right-radius: inherit;
  border-top-right-radius: inherit;
}

.conference-view-item-screenshare-next:hover {
  background: linear-gradient(to left, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 40%, rgba(255,255,255,0.1) 65%, transparent 100%);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/conference-view/ConferenceView.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,SAAS;EACT,gDAAgD;EAChD,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,6FAA6F;EAC7F,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,8DAA8D;EAC9D,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;EACd,uBAAuB;;EAEvB;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,0CAA0C;EAC5C;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,8CAA8C;EAC9C,iCAAiC;EACjC,uDAAuD;EACvD,sDAAsD;EACtD,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,iDAAiD;EACjD,gDAAgD;EAChD,UAAU;EACV,4CAA4C;EAC5C,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,OAAO;EACP,2CAA2C;EAC3C,8DAA8D;AAChE;;AAEA;EACE,QAAQ;EACR,0CAA0C;EAC1C,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,SAAS;EACX;AACF;;AAEA;EACE,sDAAsD;EACtD,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,iCAAiC;EACjC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,oCAAoC;EACpC,UAAU;EACV,iCAAiC;EACjC,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uIAAuI;EACvI,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,wIAAwI;AAC1I;;AAEA;EACE,UAAU;EACV,sIAAsI;EACtI,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,uIAAuI;AACzI","sourcesContent":[".conference-view-container {\n  width: 100%;\n  height: 0;\n  background-color: var(--dialog-background-color);\n  transition: all 0.5s ease-out;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n\n  --conference-view-item-height: 240px;\n  --conference-view-padding: var(--dialog-element-gap);\n}\n\n.conference-view-container-visible {\n  height: calc(var(--conference-view-item-height) + (2 * var(--conference-view-padding)) + 2px);\n  border-bottom: 1px solid var(--border-color);\n  pointer-events: all;\n}\n\n.conference-view-scroll-container {\n  overflow-x: auto;\n  overflow-y: hidden;\n  flex-grow: 1;\n}\n\n.conference-view-user-list {\n  width: fit-content;\n  min-width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: var(--conference-view-padding);\n  display: flex;\n  flex-direction: row;\n  gap: var(--conference-view-padding);\n  align-items: center;\n  justify-content: center;\n  background-color: var(--light-blue-background-color);\n}\n\n.conference-view-item {\n  position: relative;\n  height: var(--conference-view-item-height);\n  width: calc(var(--conference-view-item-height) * 1.3333333333);\n  border: 1px solid var(--border-color);\n  border-radius: var(--dialog-border-radius);\n  flex-shrink: 0;\n  background-color: white;\n\n  > video {\n    width: 100%;\n    height: 100%;\n    border-radius: var(--dialog-border-radius);\n  }\n\n  > img {\n    position: absolute;\n    height: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    border-radius: var(--dialog-border-radius);\n  }\n}\n\n.conference-view-item-name {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--blue-background-color);\n  color: var(--text-contrast-color);\n  border-top-right-radius: var(--input-element-gap-small);\n  border-top-left-radius: var(--input-element-gap-small);\n  padding: 0 var(--input-element-gap-small);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.conference-view-button-container-left,\n.conference-view-button-container-right {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: var(--conference-view-padding);\n  align-items: center;\n  justify-content: flex-start;\n  padding: var(--conference-view-padding);\n  box-sizing: border-box;\n}\n\n.conference-view-button-container-left .icon-display-numbered,\n.conference-view-button-container-right .icon-display-numbered {\n  flex-direction: column;\n  padding: 0;\n}\n\n.conference-view-button-container-left {\n  border-right: 1px solid var(--border-color);\n}\n\n.conference-view-button-container-right {\n  border-left: 1px solid var(--border-color);\n}\n\n.conference-view-outer-left-container,\n.conference-view-outer-right-container {\n  position: absolute;\n  top: 100%;\n  padding: calc(var(--conference-view-padding) / 2);\n  background-color: var(--dialog-background-color);\n  z-index: 1;\n  border-bottom: 1px solid var(--border-color);\n  border-top: 1px solid var(--border-color);\n  opacity: 0.75;\n}\n\n.conference-view-outer-left-container {\n  left: 0;\n  border-right: 1px solid var(--border-color);\n  border-bottom-right-radius: var(--overlay-panel-border-radius);\n}\n\n.conference-view-outer-right-container {\n  right: 0;\n  border-left: 1px solid var(--border-color);\n  border-bottom-left-radius: var(--overlay-panel-border-radius);\n}\n\n.confenrence-view-session-name-container {\n  height: var(--input-element-height);\n  min-width: var(--input-element-height);\n  padding: 0 var(--conference-view-padding);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n\n  > h2 {\n    margin: 0;\n  }\n}\n\n.conference-view-item-speaking {\n  -webkit-box-shadow: 0px 0px 10px 2px var(--warn-color);\n  box-shadow: 0px 0px 10px 2px var(--warn-color);\n  transition: all 0.5s ease-out;\n}\n\n.conference-view-item-mainstream-container,\n.conference-view-item-substream-container {\n  background-color: var(--dark-grey);\n}\n\n.conference-view-item-shared-stream {\n  position: relative;\n}\n\n.conference-view-item-shared-stream,\n.conference-view-item-mainstream,\n.conference-view-item-substream,\n.conference-view-item-mainstream-container {\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.conference-view-item-substream-container {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 40%;\n  height: 40%;\n  cursor: zoom-in;\n  border-radius: inherit;\n}\n\n.conference-view-item-maximize-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n  stroke: var(--dialog-background-color);\n  stroke-opacity: 0.75;\n  stroke-width: 20;\n}\n\n.conference-view-item-mainstream-container:hover .conference-view-item-maximize-button {\n  opacity: 1;\n}\n\n.conference-view-item-toggle-stream-button {\n  position: absolute;\n  bottom: var(--input-element-gap-small);\n  left: var(--input-element-gap-small);\n  opacity: 0;\n  transition: opacity 0.5s ease-out;\n  stroke: var(--dialog-background-color);\n  stroke-opacity: 0.75;\n  stroke-width: 20;\n}\n\n.conference-view-item-mainstream-container:hover .conference-view-item-toggle-stream-button {\n  opacity: 1;\n}\n\n.conference-view-empty {\n  font-size: var(--font-size-l);\n}\n\n.conference-view-item-screenshare-previous,\n.conference-view-item-screenshare-next {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  width: var(--input-element-height);\n  cursor: pointer;\n  stroke: var(--dialog-background-color);\n  stroke-opacity: 0.75;\n  stroke-width: 20;\n  font-size: var(--font-size-xl);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.conference-view-item-screenshare-previous {\n  left: 0px;\n  background: linear-gradient(to right, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.2) 40%, rgba(255,255,255,0.1) 60%, transparent 100%);\n  border-bottom-left-radius: inherit;\n  border-top-left-radius: inherit;\n}\n\n.conference-view-item-screenshare-previous:hover {\n  background: linear-gradient(to right, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 40%, rgba(255,255,255,0.1) 65%, transparent 100%);\n}\n\n.conference-view-item-screenshare-next {\n  right: 0px;\n  background: linear-gradient(to left, rgba(255,255,255,0.5) 0%, rgba(255,255,255,0.2) 40%, rgba(255,255,255,0.1) 60%, transparent 100%);\n  border-bottom-right-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.conference-view-item-screenshare-next:hover {\n  background: linear-gradient(to left, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.25) 40%, rgba(255,255,255,0.1) 65%, transparent 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
